// TODO: Move this component to silhoutte
import {
  Avatar as MuiAvatar,
  AvatarProps as MuiAvatarProps,
  CreateCSSProperties,
  FortoLogoLightIcon,
  Typography,
  TypographyProps,
  useTheme,
} from '@freighthub/silhouette-core'
import { FC } from 'react'

import { INITIALS_AVATAR, THUMBNAIL_AVATAR } from './AvatarType'
import { AvatarSize, IAvatarProps } from './IAvatarProps'

export const testIds = {
  fortoLogo: 'avatar-forto_avatar',
}

const sizeMap: Record<AvatarSize, { size: number; variant: TypographyProps['variant'] }> = {
  small: { size: 24, variant: 'body3-medium' },
  medium: { size: 32, variant: 'body2-medium' },
  large: { size: 40, variant: 'body2-medium' },
}

const getDimensions = (size: number): { height: number; width: number } => ({ height: size, width: size })

/**
 * In response to this issue
 * @see https://forto.atlassian.net/browse/PA-3150
 * When anyone uses the avatar initials 'SS' we will censor it to 'S'
 */
const censorInitials = (initials: string) => {
  if (initials?.toUpperCase() === 'SS') {
    return 'S'
  }
  return initials
}

export const Avatar: FC<IAvatarProps & MuiAvatarProps> = ({
  avatar,
  avatarType,
  className = '',
  'data-testid': testId,
  fullName,
  userType = 'default',
  onClick,
  children,
  size = 'medium',
}) => {
  const dataTestId = testId || avatarType
  const theme = useTheme()
  const userTypeStyleConfig: Record<'customer' | 'fortie' | 'default', CreateCSSProperties> = {
    customer: {
      bgcolor: theme.palette.highlight.dark,
      color: theme.palette.common.white,
    },
    fortie: {
      bgcolor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    default: {
      bgcolor: theme.palette.header.background,
      color: theme.palette.common.white,
    },
  }

  const dimensions = getDimensions(sizeMap[size].size)

  if (avatarType === INITIALS_AVATAR) {
    return (
      <MuiAvatar
        className={className}
        data-testid={dataTestId}
        onClick={onClick}
        sx={{ ...userTypeStyleConfig[userType], ...dimensions }}
      >
        {children || (
          <Typography color="inherit" variant={sizeMap[size].variant}>
            {censorInitials(avatar)}
          </Typography>
        )}
      </MuiAvatar>
    )
  }

  if (avatarType === THUMBNAIL_AVATAR) {
    return (
      <MuiAvatar
        className={className}
        data-testid={dataTestId}
        onClick={onClick}
        src={avatar}
        alt={fullName}
        sx={dimensions}
      />
    )
  }
  // Default: FORTO AVATAR
  return (
    <MuiAvatar
      className={className}
      data-testid={dataTestId}
      onClick={onClick}
      sx={{ ...userTypeStyleConfig.default, ...dimensions }}
    >
      <FortoLogoLightIcon fontSize="small" data-testid={testIds.fortoLogo} />
    </MuiAvatar>
  )
}
